import styled from 'styled-components';

import * as api from '../../../api';

import styles from './index.module.css';

import { ReactComponent as ActivityIcon } from '../../../assets/activity.svg';
import { ReactComponent as AlertIcon } from '../../../assets/alert.svg';
import { ReactComponent as ArchiveIcon } from '../../../assets/archive.svg';
import { ReactComponent as AwardIcon } from '../../../assets/award.svg';
import { ReactComponent as BookIcon } from '../../../assets/book.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/calendar.svg';
import { ReactComponent as ChatIcon } from '../../../assets/chat.svg';
import { ReactComponent as CheckIcon } from '../../../assets/check.svg';
import { ReactComponent as ClipboardIcon } from '../../../assets/clipboard.svg';
import { ReactComponent as ClockIcon } from '../../../assets/clock.svg';
import { ReactComponent as CreditCardIcon } from '../../../assets/credit-card.svg';
import { ReactComponent as EditIcon } from '../../../assets/edit.svg';
import { ReactComponent as FlagIcon } from '../../../assets/flag.svg';
import { ReactComponent as FileIcon } from '../../../assets/file.svg';
import { ReactComponent as FolderIcon } from '../../../assets/folder.svg';
import { ReactComponent as GiftIcon } from '../../../assets/gift.svg';
import { ReactComponent as HeartIcon } from '../../../assets/heart.svg';
import { ReactComponent as HelpIcon } from '../../../assets/help.svg';
import { ReactComponent as HomeIcon } from '../../../assets/home.svg';
import { ReactComponent as InfoIcon } from '../../../assets/info.svg';
import { ReactComponent as InsuranceIcon } from '../../../assets/insurance.svg';
import { ReactComponent as LinkIcon } from '../../../assets/link.svg';
import { ReactComponent as LocationIcon } from '../../../assets/location.svg';
import { ReactComponent as LockIcon } from '../../../assets/lock.svg';
import { ReactComponent as MyChartSvg } from '../../../assets/mychart.svg';
import { ReactComponent as MyHealthSvg } from '../../../assets/my-health.svg';
import { ReactComponent as PaymentIcon } from '../../../assets/payment.svg';
import { ReactComponent as PeopleIcon } from '../../../assets/people.svg';
import { ReactComponent as PersonIcon } from '../../../assets/person.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/phone.svg';
import { ReactComponent as ReferralIcon } from '../../../assets/referral.svg';
import { ReactComponent as SmileIcon } from '../../../assets/smile.svg';
import { ReactComponent as StarIcon } from '../../../assets/star.svg';
import { ReactComponent as WatchIcon } from '../../../assets/watch.svg';

import MitHealthLogo from '../../../assets/mithealth.png';

const NKCH_ORGANIZATION_IDENTIFIER = 'dd9dbde1-b8eb-4d3b-8a2e-e9e57fc78d9c';
const MIT_ORGANIZATION_IDENTIFIER = '3631257e-625c-4703-a5c4-c6a15c6041cb';

const AvailableIcon = api.OrganizationAssistantConfiguration.AvailableIcon;

interface Props {
  iconName?: api.OrganizationAssistantConfiguration.AvailableIcon;
  organizationId?: string;

  // style
  margin?: string;
  color?: string;
}

const styleProps = { className: styles.icon };

const ICON_MAP: {
  [key in api.OrganizationAssistantConfiguration.AvailableIcon]: () => JSX.Element;
} = {
  [AvailableIcon.Activity]: () => <ActivityIcon {...styleProps} />,
  [AvailableIcon.Alert]: () => <AlertIcon {...styleProps} />,
  [AvailableIcon.Archive]: () => <ArchiveIcon {...styleProps} />,
  [AvailableIcon.Award]: () => <AwardIcon {...styleProps} />,
  [AvailableIcon.Book]: () => <BookIcon {...styleProps} />,
  [AvailableIcon.Calendar]: () => <CalendarIcon {...styleProps} />,
  [AvailableIcon.Chat]: () => <ChatIcon {...styleProps} />,
  [AvailableIcon.Check]: () => <CheckIcon {...styleProps} />,
  [AvailableIcon.Clock]: () => <ClockIcon {...styleProps} />,
  [AvailableIcon.Clipboard]: () => <ClipboardIcon {...styleProps} />,
  [AvailableIcon.CreditCard]: () => <CreditCardIcon {...styleProps} />,
  [AvailableIcon.Edit]: () => <EditIcon {...styleProps} />,
  [AvailableIcon.Flag]: () => <FlagIcon {...styleProps} />,
  [AvailableIcon.File]: () => <FileIcon {...styleProps} />,
  [AvailableIcon.Folder]: () => <FolderIcon {...styleProps} />,
  [AvailableIcon.Gift]: () => <GiftIcon {...styleProps} />,
  [AvailableIcon.Heart]: () => <HeartIcon {...styleProps} />,
  [AvailableIcon.Help]: () => <HelpIcon {...styleProps} />,
  [AvailableIcon.Home]: () => <HomeIcon {...styleProps} />,
  [AvailableIcon.Info]: () => <InfoIcon {...styleProps} />,
  [AvailableIcon.Insurance]: () => <InsuranceIcon {...styleProps} />,
  [AvailableIcon.Link]: () => <LinkIcon {...styleProps} />,
  [AvailableIcon.Location]: () => <LocationIcon {...styleProps} />,
  [AvailableIcon.Lock]: () => <LockIcon {...styleProps} />,
  [AvailableIcon.Payment]: () => <PaymentIcon {...styleProps} />,
  [AvailableIcon.People]: () => <PeopleIcon {...styleProps} />,
  [AvailableIcon.Person]: () => <PersonIcon {...styleProps} />,
  [AvailableIcon.Phone]: () => <PhoneIcon {...styleProps} />,
  [AvailableIcon.Referral]: () => <ReferralIcon {...styleProps} />,
  [AvailableIcon.Smile]: () => <SmileIcon {...styleProps} />,
  [AvailableIcon.Star]: () => <StarIcon {...styleProps} />,
  [AvailableIcon.Watch]: () => <WatchIcon {...styleProps} />,
};

const ConfigurableIcon: React.FC<Props> = ({
  iconName,
  organizationId,
  margin,
  color,
}) => {
  const getIcon = () => {
    if (organizationId === NKCH_ORGANIZATION_IDENTIFIER && !iconName) {
      return <MyHealthIcon />;
    } else if (organizationId === MIT_ORGANIZATION_IDENTIFIER && !iconName) {
      return <MitHealthLogoImg src={MitHealthLogo} />;
    }
    return !!iconName ? ICON_MAP[iconName]() : <MyChartIcon />;
  };
  return (
    <IconWrapper $margin={margin} $color={color}>
      {getIcon()}
    </IconWrapper>
  );
};

const MitHealthLogoImg = styled.img`
  height: 24px;
`;

const MyHealthIcon = styled(MyHealthSvg)`
  stroke: none !important;
`;

const MyChartIcon = styled(MyChartSvg)`
  stroke: none !important;
`;

const IconWrapper = styled.span.attrs<{
  $margin?: string;
  $color?: string;
}>((props) => ({
  $margin: props.$margin ?? '0',
  $color: props.$color,
}))`
  margin: ${(props) => props.$margin};

  svg {
    overflow: visible;
    stroke: ${(props) => props.$color};
  }
`;

export default ConfigurableIcon;
